import styled from 'styled-components';
import { useLayoutEffect, useRef, useState } from 'react';

export interface DropperProps {
    children?: any;
    target: HTMLElement;

    /** Origin position of Popover */
    originPosition?: { x: 'right' | 'left' | 'center', y: 'top' | 'bottom' | 'center' };
    /** Origin position on target to which Popover will mount  */
    anchorPosition?: { x: 'right' | 'left' | 'center', y: 'top' | 'bottom' | 'center' };
    offset?: Position;
}

type AnchorPosition = { x: 'right' | 'left' | 'center'; y: 'top' | 'center' | 'bottom'; }
type Position = { x: number; y: number; }
type Size = { minWidth: number; }

function PopoverBody({ children, target, originPosition = { x: 'center', y: 'center' }, anchorPosition = { x: 'center', y: 'center' }, offset = { x: 0, y: 0 } }: DropperProps) {
    const selfRef: any = useRef();

    const [position, setPosition] = useState<Position>(() => ({ x: 0, y: 0 }));
    const [size, setSize] = useState<Size>(() => ({ minWidth: 0 }));

    function calcPosition() {
        const targetRect = target.getBoundingClientRect();
        const selfRect = (selfRef.current as HTMLElement).getBoundingClientRect();

        let size = { minWidth: targetRect.width }
        selfRect.width = Math.max(size.minWidth, selfRect.width);

        const originOffset: { [axis in keyof AnchorPosition]: { [position in AnchorPosition[axis]]: () => number } } = {
            x: { right: () => -selfRect.width, center: () => -selfRect.width / 2, left: () => 0 },
            y: { top: () => 0, center: () => -selfRect.height / 2, bottom: () => -selfRect.height }
        }

        const targetOffset: { [axis in keyof AnchorPosition]: { [position in AnchorPosition[axis]]: () => number } } = {
            x: { right: () => targetRect.width, center: () => targetRect.width / 2, left: () => 0 },
            y: { top: () => 0, center: () => targetRect.height / 2, bottom: () => targetRect.height }
        }

        let position = { x: targetRect.x + originOffset.x[originPosition.x]() + targetOffset.x[anchorPosition.x]() + offset.x, y: targetRect.y + originOffset.y[originPosition.y]() + targetOffset.y[anchorPosition.y]() + offset.y }

        const invertPositionX: { [key in AnchorPosition['x']]: AnchorPosition['x'] } = { right: 'left', center: 'center', left: 'right' };
        const invertPositionY: { [key in AnchorPosition['y']]: AnchorPosition['y'] } = { top: 'bottom', center: 'center', bottom: 'top' };

        if (((position.x + selfRect.width > window.innerWidth) && (position.x + selfRect.width / 2 > targetRect.x + targetRect.width / 2)) ||
            ((position.x < 0) && (position.x + selfRect.width / 2 < targetRect.x + targetRect.width / 2))) {
            position.x = targetRect.x + originOffset.x[invertPositionX[originPosition.x]]() + targetOffset.x[invertPositionX[anchorPosition.x]]() - offset.x;
        }

        if (((position.y + selfRect.height > window.innerHeight) && (position.y + selfRect.height / 2 > targetRect.y + targetRect.height / 2)) ||
            ((position.y < 0) && (position.y + selfRect.height / 2 < targetRect.y + targetRect.height / 2))) {
            position.y = targetRect.y + originOffset.y[invertPositionY[originPosition.y]]() + targetOffset.y[invertPositionY[anchorPosition.y]]() - offset.y;
        }

        if (position.x + selfRect.width > window.innerWidth) position.x -= (position.x + selfRect.width) - (window.innerWidth);
        if (position.x < 0) position.x = 0;

        if (position.y + selfRect.height > window.innerHeight) position.y -= (position.y + selfRect.height) - (window.innerHeight);
        if (position.y < 0) position.y = 0;

        position.y += window.scrollY;

        setPosition(position);
        setSize(size);
    }

    useLayoutEffect(() => {
        if (!target) return;

        calcPosition();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (selfRef?.current) selfRef.current.focus();

    return (
        <Wrapper ref={selfRef} style={{ top: position.y, left: position.x, minWidth: size.minWidth }} onClick={() => console.log('africa')}>
            <div className='tooltip'>
                {children}
            </div>
        </Wrapper>)
}

const Wrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    color: #ffffff;
    font-weight: 700;
    z-index: 1000;

    /* padding: 10px; */

    .tooltip {
        border-radius: ${props => props.theme.borderRadius};
        background-color: ${props => props.theme.backgroundColor};
    }
`

export default PopoverBody;